import { AxiosResponse } from 'axios'
import { UserService } from './User.types'
import { NestAPI } from '../../nestapi'
import {
  CreateUserDTO,
  UpdateUserDTO,
  UserWithBusiness,
  NewUserResponse,
  UserInvite,
  PostResponse,
  Auth0User,
  User,
} from '@marketing-milk/interfaces'

export class UserServiceImplementation implements UserService {
  async create(userDTO: CreateUserDTO): Promise<PostResponse<NewUserResponse>> {
    const newUser: PostResponse<NewUserResponse> = await NestAPI.post('users', userDTO)
    return newUser
  }
  async invite(
    userDTO: CreateUserDTO
  ): Promise<PostResponse<{ invitedUser: any; message: string }>> {
    const newUser: PostResponse<{ invitedUser: any; message: string }> = await NestAPI.post(
      'user-invites',
      userDTO
    )
    return newUser
  }
  async getInvites(paginationParams?: any) {
    const queryString = paginationParams
      ? `?${new URLSearchParams(paginationParams).toString()}`
      : ''
    const response: {
      invites: UserInvite[]
      count: number
    } = await NestAPI.get(`user-invites${queryString}`)
    return response
  }
  async getInvitedByUsers(): Promise<User[]> {
    const users: User[] = await NestAPI.get(`user-invites/invited-by-users`)
    return users
  }
  async resendInvite(email: string): Promise<PostResponse<{ message: string }>> {
    const result: PostResponse<{ message: string }> = await NestAPI.post(
      `user-invites/resend/${encodeURIComponent(email)}`
    )
    return result
  }
  async deleteInvite(email: string): Promise<void> {
    await NestAPI.delete(`user-invites/${encodeURIComponent(email)}`)
  }
  async getSignupLink(email: string): Promise<{ signupUrl: string }> {
    const result: { signupUrl: string } = await NestAPI.get(
      `user-invites/${encodeURIComponent(email)}/signup-link`
    )
    return result
  }
  async getAll() {
    const users: UserWithBusiness[] = await NestAPI.get('users')
    return users
  }
  async getAllAuth0Users() {
    const users: Auth0User[] = await NestAPI.get('users/auth0/users')
    return users
  }
  async getByID(userID: number) {
    const users: UserWithBusiness = await NestAPI.get(`users/${userID}`)
    return users
  }
  async updateByID(userID: number, userDTO: UpdateUserDTO) {
    await NestAPI.patch(`users/${userID}`, userDTO)
  }
  async deleteByID(userID: number) {
    await NestAPI.delete(`users/${userID}`)
  }

  async getAuth0User(email: string) {
    const user: Auth0User = await NestAPI.post(`users/auth0`, { email })
    return user
  }
}
